import React from 'react'
import { Container, Image, Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const NotFound = () => {
    return (
        <div className='d-flex justify-content-center'>
            <img src="/images/no-data.png" height={150} style={{ marginTop: 100}}/>
        </div>
    )
}
